/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import AnnotationsHandler from '..';
import { C11nEnv } from '../../interpreter/c11n-env';
import RefreshManager from '../../refresh/refresh-manager';

AnnotationsHandler.registerHandler('@REFRESH', (value: string, c11nEnv: C11nEnv) => {
  const caseKey = c11nEnv.getCaseInfo().getKey();
  const context = c11nEnv.getContextName();
  const pageReference = c11nEnv.getPageReference();
  const refreshOptions = { autoDetectRefresh: true, preserveClientChanges: false };

  RefreshManager.registerForRefresh(
    'PROP_CHANGE',
    c11nEnv.getActionsApi().refreshCaseView.bind(c11nEnv.getActionsApi(), caseKey, '', pageReference, {
      ...refreshOptions,
      refreshFor: `${pageReference.replace('caseInfo.content', '')}${value}`,
      resetForm: true
    }),
    `${pageReference}${value}`,
    `${context}/${pageReference}`,
    context
  );
});
